import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import { LoadingComponent } from "../components/common";
import SidebarComponent from "../components/home/sidebarComponent";
import PayrollComponent from "../components/payroll/payrollComponent";
import { SessionUserStyles } from "./PagesStyle";

class PayrollPage extends Component {
	render() {
		const { classes, isLoading, mixpanel } = this.props;

		return (
			<div className={classes.root}>
				<CssBaseline />
				<SidebarComponent />
				<main className={classes.content}>
					<LoadingComponent isLoading={isLoading} />
					<div className={classes.appBarSpacer} />
					<PayrollComponent mixpanel={mixpanel} />
				</main>
			</div>
		);
	}
}

PayrollPage.propTypes = {
	classes: PropTypes.object.isRequired,
	isLoading: PropTypes.bool
};

const mapStateToProps = state => ({
	isLoading: state.employees.isLoading || state.payroll.isLoading
});

export default connect(
	mapStateToProps,
	null
)(withStyles(SessionUserStyles)(PayrollPage));
